export default "__VITE_ASSET__Btwwfu$P__"